import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const createSeniormaster=(request,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.CREATE_SENIOR_MASTER_START
    })
    const options={
        url:`${api}/auth/smaster/signup`,
        method:'POST',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:request
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.CREATE_SENIOR_MASTER_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.CREATE_SENIOR_MASTER_FAIL,
                payload:getMessage(error)
            }))
}